import React, { useCallback } from "react"

import { Switch } from "@coval/ui"

import { FieldLabel } from "@/components/shared/forms/FieldLabel"

import type { WebSocketFieldProps } from "./types"

export const PlaybackMarkerFields: React.FC<WebSocketFieldProps> = ({
  metadata,
  onMetadataUpdate,
  disabled = false,
}) => {
  const isEnabled = Boolean(metadata.marks_enabled)

  const handleToggle = useCallback(
    (checked: boolean) => {
      onMetadataUpdate({ marks_enabled: checked })
    },
    [onMetadataUpdate],
  )

  return (
    <div className="flex items-center gap-3">
      <Switch
        id="playback-markers-enabled"
        checked={isEnabled}
        onCheckedChange={handleToggle}
        disabled={disabled}
      />
      <div className="flex flex-col gap-1">
        <FieldLabel htmlFor="playback-markers-enabled">
          Playback Markers
        </FieldLabel>
        <p className="text-xs text-coval-text-muted">
          When enabled, {`{"type": "mark", "mark": {"name": "..."}}`} messages
          from the agent are echoed back once all audio preceding the mark has
          been processed.
        </p>
      </div>
    </div>
  )
}
